export default __webpack_public_path__ + "static/TIGR_Waveguide_04052025-54f780dc0dd5675441a7986c907d98b1.gif";